<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="text-center">Create a club</h2>
        <br>
        <b-form class="">
          <b-form-group id="name" label-for="name">
            <span>Club name</span>
            <b-form-input 
              id="name"
              v-model="form.name.value" 
              :state="form.name.error.state"
              placeholder="name"
              required
            />
            <b-form-invalid-feedback :state="form.name.error.state">
              {{ form.name.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="description" label-for="description">
            <span>Club description</span>
            <b-form-textarea 
              id="description"
              v-model="form.description.value" 
              :state="form.description.error.state"
              placeholder="description"
              rows="6"
              required
            />
            <b-form-invalid-feedback :state="form.description.error.state">
              {{ form.description.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="country" label-for="country">
            <span>Club country</span>
            <multiselect
              v-model="form.country.value"
              :options="countries"
              placeholder="Search for a country"
              select-label=""
              :multiple="false"
              :searchable="true"
              :hide-selected="false"
            >
            </multiselect>
            <b-form-invalid-feedback :state="form.country.error.state">
              {{ form.country.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-checkbox
            id="isPrivate"
            v-model="form.isPrivate.value"
            name="isPrivate"
            :value="true"
            :unchecked-value="false"
          >
            <span>Is it a private club?</span>&nbsp;<fa-icon icon="question-circle" v-tooltip:right="`Public clubs can be joined by anyone. They appear publicly on the app. Private clubs can only be joined by people who have the invitation link. They don't appear publicly on the app.`" />
          </b-form-checkbox>
          <b-form-invalid-feedback :state="form.isPrivate.error.state">
            {{ form.isPrivate.error.value }}
          </b-form-invalid-feedback>
          <br><br><br>
          <c-button :onClick="onCancel" variant="secondary">Cancel</c-button>
          <c-button :onClick="onNext" variant="primary" class="right-align">Create</c-button>
          <br>
          <span class="success right-align">{{ formSuccess }}</span>
          <span class="failure right-align">{{ formFailure }}</span>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import Multiselect from 'vue-multiselect';
  import countries from '@/countries.js';

  export default {
    name: 'CreateClub',
    components: { CButton, Multiselect },
    props: {

    },
    data() {
      return {
        form: {
          name: {
            value: '',
            error: {}
          },
          description: {
            value: '',
            error: {}
          },
          country: {
            value: '',
            error: {}
          },
          isPrivate: {
            value: false,
            error: {}
          },
        },
        formSuccess: '',
        formFailure: '',
        countries
      }
    },
    created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      onCancel(event) {
        this.$router.push({ name: 'Home' });
      },
      async onNext() {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/createClub.graphql'),
          variables: {
            name: this.form.name.value,
            description: this.form.description.value,
            country: this.form.country.value,
            isPrivate: this.form.isPrivate.value,
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          this.formSuccess = "Club successfully created";
          this.$router.push({ name: 'Club', params: { id: result.data.createClub.id }});
        }
      }
    }
  }
</script>

<style scoped>

</style>
